import { useTranslation } from 'react-i18next';
import { goToLogin } from '../../../../api/auth';
import { Thumbnail } from '../../../../components/thumbnail/thumbnail';
import { SvgCart } from '../../../../icons';
import { ImageProps } from '../../../../interfaces';

import styles from './episode.module.scss';

interface EpisodeThumbnailLogInProps extends React.HTMLAttributes<HTMLButtonElement> {
  image: ImageProps;
  progress?: number;
}

export function EpisodeThumbnailLogIn({ image, progress, ...rest }: EpisodeThumbnailLogInProps) {
  const { t } = useTranslation();

  return (
    <button
      className={styles.thumbnailButton}
      onClick={(e) => {
        e.stopPropagation();
        goToLogin();
      }}
      {...rest}
    >
      <Thumbnail image={image} icon={SvgCart} progress={progress} iconText={t('get access')} />
    </button>
  );
}
